export const serviceGroupActionTypes = {
    SET_SERVICE_GROUPS: 'SET_SERVICE_GROUPS',
    SET_SERVICE_GROUP: 'SET_SERVICE_GROUP',
    SET_TEXT_CONFIGS: 'SET_TEXT_CONFIGS',
    SET_TIME_CONFIGS: 'SET_TIME_CONFIGS',
    SET_OPEN_HOURS: 'SET_OPEN_HOURS',
    SET_COMMENT: 'SET_COMMENT'
};